const getState = (state) => state.questions;

export const getQuestions = (state) => getState(state).list;
